import styled from "styled-components";

export const StyledCustomTaskForm = styled.div`
    padding-right: 6px;
    margin-top: 16px;
    max-height: 65dvh;
    overflow-y: auto;
`;
